import Shimmer from "@/components/Shimmer";

const SmsOnboardingPolicyContentLoading = () => (
  <div>
    <div className="mb-20 flex flex-col items-center gap-10">
      <Shimmer height={50} width="60%" />
      <Shimmer height={35} width="30%" />
    </div>
    <div className="mt-20 md:mt-30">
      <Shimmer height={80} />
    </div>
    <div className="mt-20 md:mt-30">
      <Shimmer height={80} />
    </div>
    <div className="mt-40 flex flex-col items-center">
      <Shimmer height={54} width={212} />
    </div>
  </div>
);

export default SmsOnboardingPolicyContentLoading;
